import { render, staticRenderFns } from "./RestorePassword.vue?vue&type=template&id=1ff03110&scoped=true"
import script from "./RestorePassword.vue?vue&type=script&lang=js"
export * from "./RestorePassword.vue?vue&type=script&lang=js"
import style0 from "./RestorePassword.vue?vue&type=style&index=0&id=1ff03110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff03110",
  null
  
)

export default component.exports